/**
 * English language
 * @type {Object}
 *
 * Example: {{ $t('someWord') }}
 */

const en = {
  views: {
    login: {
      signInButton: "Sign in",
      forgotButton: "Forgot your password?",
      rememberMeButton: "Remember me",
    },
    carousel: {
      line1: "Ela Quote by Scratch<br><br>",
      line2: "Log in to the adventure",
    },
  },
  components: {},
};

export default en;
